import type { SVGProps } from 'react'
import { SPRITE } from '#constants.ts'
import { cn } from '#utils/cn.ts'

export type DsIconProps = Omit<IconProps, 'id'>

type IconNames =
  | 'arrowLeftBar'
  | 'arrowLeftToLine'
  | 'arrowRight'
  | 'arrowRightBar'
  | 'brightnessUp'
  | 'caseSensitive'
  | 'check'
  | 'chevronCompactRight'
  | 'chevronDown'
  | 'chevronLeft'
  | 'circle'
  | 'circlePlus'
  | 'clock'
  | 'deviceDesktop'
  | 'deviceMobile'
  | 'ellipses'
  | 'error'
  | 'externalLink'
  | 'funnel'
  | 'heartFilled'
  | 'homeFilled'
  | 'infoCircle'
  | 'link'
  | 'loader'
  | 'lock'
  | 'logout'
  | 'moonFilled'
  | 'plus'
  | 'restore'
  | 'settings'
  | 'sortDescending'
  | 'trashXFilled'
  | 'unfoldVertical'
  | 'user'
  | 'x'
  | 'zoom'
  | 'zoomIn'
  | 'zoomOut'

interface IconProps
  extends Partial<Omit<SVGProps<SVGSVGElement>, 'stroke' | 'id'>> {
  name: IconNames
  label?: string
  size?: string | number
  stroke?: string
}

const iconClasses = {
  check: 'text-ok-4',
  error: 'text-flag-5',
  loader: 'animate-spin',
} as { [key in IconNames]: string }

// The svg sprite is lives in public dir
export function Icon({
  className,
  name,
  label,
  size = 18,
  strokeWidth = 2,
  ...props
}: IconProps) {
  return (
    <svg
      {...props}
      {...(name.endsWith('Filled')
        ? { fill: 'currentColor' }
        : {
            fill: 'none',
            stroke: 'currentColor',
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeWidth,
          })}
      className={cn('inline shrink-0', iconClasses[name], className)}
      height={size}
      role={label ? undefined : 'presentation'}
      viewBox='0 0 24 24'
      width={size}
    >
      {label ? <title>{label}</title> : null}
      <use href={`${SPRITE}#${name}`} />
    </svg>
  )
}
